import {Banner} from '../components/c-banner/c-banner';
import {FAQ} from '../components/c-faq/c-faq';
import {Header} from '../components/c-header/c-header';
import {MenuMobile} from '../components/c-menu-mobile/c-menu-mobile';
import {SubNav} from "../components/c-sub-nav/c-sub-nav";
import {Testimonials} from "../components/c-testimonials/c-testimonials";
import {SignUpPopup} from "../components/c-signup-popup/c-signup-popup";
import {YoutubePlaceholder} from "../components/c-youtube-placeholder/c-youtube-placeholder";
import {IntercomDummy} from "../components/c-intercom-dummy/c-intercom-dummy";
import {CookieNotice} from "../components/c-cookie-notice/c-cookie-notice";
import {CookiePreferences} from "../components/c-cookie-preferences/c-cookie-preferences";

import {PageController} from "../helpers/PageController";
import {VacancyPageController} from "../templates/vacancy-page/VacancyPage.controller";
import {ExtensiveFormPageController} from "../templates/extensive-form-page/ExtensiveFormPage.controller";
import {CompactFormPageController} from "../templates/compact-form-page/CompactFormPage.controller";
import {QuickNavigator} from "../components/c-quick-navigator/c-quick-navigator";
import {BackButton} from "../components/c-back-button/c-back-button";
import {FormVacancy} from "../templates/vacancy-perza/vacancy-perza";

/**
 * General components used in multiple pages
 */
new BackButton();
new Banner();
new FAQ();
new Header();
new MenuMobile();
new SubNav();
new Testimonials(7000);
new SignUpPopup();
new YoutubePlaceholder();
new IntercomDummy();
new CookieNotice();
new CookiePreferences();
new QuickNavigator();
new FormVacancy();

/**
 * Controllers
 *
 * Only initiate these controllers if they are defined in the
 * template as data-controller="VacancyPageController"
 *
 * prevents unwanted execution of scripts on random pages
 */
new PageController({
    VacancyPageController,
    CompactFormPageController,
    ExtensiveFormPageController
});
